// The band the user can actually see: the nearest scrolling ancestor, or the window without one.
// The GPS viewer scrolls inside a box that starts below its topbar, not at the window top.
const visibleBand = (el) => {
  for (let node = el.parentElement; node; node = node.parentElement) {
    if (/(auto|scroll)/.test(getComputedStyle(node).overflowY)) {
      const { top, bottom } = node.getBoundingClientRect();
      return { top, bottom };
    }
  }
  return { top: 0, bottom: window.innerHeight };
};

/**
 * FullCalendar pins the "+N autres" popover to the top of its day cell and never checks the bottom,
 * so on the last rows it spills out of view. Flip it to end on the cell bottom, or on the visible
 * bottom when the cell itself runs past it — unless that would push its header out of view.
 */
const keepInView = (root) => {
  const popover = root.querySelector('.fc-popover');
  const cell = popover && root.querySelector(`[aria-controls="${popover.id}"]`)?.closest('.fc-daygrid-day');
  if (!cell) return;
  const { top, height } = popover.getBoundingClientRect();
  const { top: cellTop, bottom: cellBottom } = cell.getBoundingClientRect();
  const band = visibleBand(root);
  const flippedTop = Math.min(cellBottom, band.bottom) - height;
  if (cellTop + height <= band.bottom || flippedTop < band.top) return;
  popover.style.top = `${popover.offsetTop + flippedTop - top}px`;
};

// Every DOM change re-places it: the popover mounts empty and grows once React renders its chips.
export const watchPopover = (root) => {
  const observer = new MutationObserver(() => keepInView(root));
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
};
